import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceCustomersRoute: InvariantJiraRoute = {
	name: 'customer-service-customers',
	path: '/jira/customer-service/customers',
	exact: true,
};
